import {
  FORM_CONTROL_SIZES,
  INPUT_BASE_CLASS,
} from '../components/input/config';
import { SIZE_MD } from '../config/constants';

export default {
  props: {
    /**
     * @model modelValue
     */
    modelValue: {
      type: [Number, String],
      default: '',
      required: false,
    },
    label: {
      type: String,
      default: null,
      required: false,
    },
    hideLabel: {
      type: Boolean,
      default: false,
      required: false,
    },
    /**
     * @values md, lg
     * @default md
     * */
    size: {
      type: String,
      default: SIZE_MD,
      required: false,
      validator: (value) => FORM_CONTROL_SIZES.includes(value),
    },
    helpText: {
      type: String,
      default: '',
      required: false,
    },
    isStatic: {
      type: Boolean,
      default: false,
      required: false,
    },
    readonly: {
      type: Boolean,
      default: false,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    placeholder: {
      type: String,
      default: '',
      required: false,
    },
  },

  computed: {
    inputAttrs() {
      const overrides = {};

      const hasInputHandler = Object.prototype.hasOwnProperty.call(this, 'input');

      if (hasInputHandler && typeof this.input === 'function') {
        overrides.onInput = (event) => this.input(event);
      }

      const hasChangeHandler = Object.prototype.hasOwnProperty.call(this, 'change');

      if (hasChangeHandler && typeof this.change === 'function') {
        overrides.onChange = (event) => this.change(event);
      }

      return {
        ...this.$attrs,
        ...overrides,
      };
    },

    labelClass() {
      const { size, hideLabel } = this;
      const classes = [];

      if (hideLabel) {
        classes.push('sr-only');
      }

      if (size !== SIZE_MD) {
        classes.push(`label-${size}`);
      }

      return classes;
    },

    baseFormControlClass() {
      const { size, validationClass } = this;

      const classes = [
        INPUT_BASE_CLASS,
        validationClass,
      ];

      if (size !== SIZE_MD) {
        classes.push(`form-control-${size}`);
      }

      return classes;
    },

    wrapperClass() {
      return [this.validationClass];
    },

    formControlClasses() {
      return [
        ...this.baseFormControlClass,
        this.formControlClass,
      ];
    },
  },
};
